import React from "react";
import { TableCell, TableRow, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
    NEGATIVE_COLOR,
    POSITIVE_COLOR,
    TRANSFER_COLOR,
    VALUE_FONT_WEIGHT,
} from "../../Constants";
import WalletIcon from "../layout/WalletIcon";
import { selectWalletById } from "../../store/walletSlice";

const TemplateExpense = ({ template, onClick }) => {
    const description = template.description || "Expense";
    const value = template.valueFrom;
    const wallet = useSelector((state) => selectWalletById(state, template.walletFrom));

    return (
        <TableRow
            sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                ...(onClick ? { cursor: "pointer" } : {}),
            }}
            onClick={(e) => onClick && onClick(template)}
            hover={!!onClick}
        >
            <TableCell padding="none" align="center" sx={{ width: 56 }}>
                <WalletIcon image={wallet?.image} sx={{ fontSize: 28 }} />
            </TableCell>
            <TableCell component="th" scope="row">
                <Typography variant="body1">{description}</Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="body1" sx={{ color: NEGATIVE_COLOR, fontWeight: VALUE_FONT_WEIGHT }}>
                    −{value}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

const TemplateIncome = ({ template, onClick }) => {
    const description = template.description || "Income";
    const value = template.valueTo;
    const wallet = useSelector((state) => selectWalletById(state, template.walletTo));

    return (
        <TableRow
            sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                ...(onClick ? { cursor: "pointer" } : {}),
            }}
            onClick={(e) => onClick && onClick(template)}
            hover={!!onClick}
        >
            <TableCell padding="none" align="center" sx={{ width: 56 }}>
                <WalletIcon image={wallet?.image} sx={{ fontSize: 28 }} />
            </TableCell>
            <TableCell component="th" scope="row">
                <Typography variant="body1">{description}</Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="body1" sx={{ color: POSITIVE_COLOR, fontWeight: VALUE_FONT_WEIGHT }}>
                    +{value}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

const TemplateTransfer = ({ template, onClick }) => {
    const description = template.description || "Transfer";
    const value = template.valueFrom ?? template.valueTo;
    const walletFrom = useSelector((state) => selectWalletById(state, template.walletFrom));
    const walletTo = useSelector((state) => selectWalletById(state, template.walletTo));

    return (
        <TableRow
            sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                ...(onClick ? { cursor: "pointer" } : {}),
            }}
            onClick={(e) => onClick && onClick(template)}
            hover={!!onClick}
        >
            <TableCell padding="none" align="center" sx={{ width: 56 }}>
                <WalletIcon image={walletFrom?.image ?? walletTo?.image} sx={{ fontSize: 28 }} />
            </TableCell>
            <TableCell component="th" scope="row">
                <Typography variant="body1">{description}</Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="body1" sx={{ color: TRANSFER_COLOR, fontWeight: VALUE_FONT_WEIGHT }}>
                    {value}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

const Template = ({ template, onTemplateClick }) => {
    const type = template.type || "EXPENSE";
    const common = { template, onClick: onTemplateClick };

    switch (type) {
        case "EXPENSE":
            return <TemplateExpense {...common} />;
        case "INCOME":
            return <TemplateIncome {...common} />;
        case "TRANSFER":
            return <TemplateTransfer {...common} />;
        default:
            return <TemplateExpense {...common} />;
    }
};

Template.propTypes = {
    template: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        description: PropTypes.string,
        type: PropTypes.string,
        valueFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        valueTo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        walletFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        walletTo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    onTemplateClick: PropTypes.func,
};

export default Template;
